import { render, staticRenderFns } from "./BarcazaEstado.vue?vue&type=template&id=58fefe77"
import script from "./BarcazaEstado.vue?vue&type=script&lang=js"
export * from "./BarcazaEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports